
import { Vue, Component, Prop } from 'vue-property-decorator';
import Doughnut from '@/features/common/components/Doughnut.vue';

@Component({
  components: {
    Doughnut,
  },
})
export default class DoughnutChart extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop({ required: true }) data!: any;

  @Prop({ default: '' }) label!: string;

  @Prop({ default: '' }) sublabel!: string;
}
